(function () {
	'use strict';

	angular
		.module('procedureModule')
		.controller('prcResponsibilityFullController', Controller);

	Controller.$inject = ['$scope',
						  '$state',
						  '$mdToast',
						  'responsibilityService',
						  'notificationService',
						  'historyCtxtService'];

	function Controller($scope,
						$state,
						$mdToast,
                        responsibilityService,
						notificationService,
						historyCtxtService) {
		// Show Reset Action?
		$scope.showResetAction = function () {
			if (!$scope.canEdit) return false;

			return $scope.ctxtBox.isDirty;
		};

		// Reset forms
		$scope.reset = function () {
			$scope.isLoading = true;
			$state.reload();
		};

		// Show Save Action
		$scope.showSaveAction = function (form) {
			if (!$scope.canEdit) return false;
			if (!$scope.boxModel.ResponsibilityID) return false;
			if (form.$invalid) return false;

			return $scope.ctxtBox.isDirty;
		};

		// Update
		$scope.updateResponsibility = function() {
			$scope.isLoading = true;

            responsibilityService
				.updateResponsibility($scope.boxModel)
				.then(function(updatedRsponsibility) {

					$mdToast.show(
						$mdToast
						.simple()
						.content('Your changes have been saved!')
						.position('top right')
						.hideDelay($scope.govNotificationDelay)
						.action('OK')
						.theme('primary')
					);

					$scope.pageIsNotDirty();
				})
				.finally(function() {
					$scope.isLoading = false;
				});
		};

		$scope.deleteResponsibility = function() {
			$scope.isLoading = true;

            responsibilityService
				.deleteResponsibility($scope.boxModel.ResponsibilityID)
				.then(function() {
					notificationService.notify('Responsibility has been deleted');
					if (!historyCtxtService.getCtxName()) {
						$state.go('root');
						return;
					}
					
					historyCtxtService.goToContext();
				})
				.finally(function() {
					$scope.isLoading = false;
				});
		};
	}
})();